import store from "@/vue/planning/store/store"
import { getCookie, getParticipantsAmount } from "@/utils/utils"

export default {  
    setSelectedPrestIds: ({state, getters, commit, dispatch}, {scrollToSummary = true, ...obj}) => {
        const prestations = getters.prestations
        const variants = getters.variants
        const selectedPrestationsAmount = getters.selectedPrestations.length
        const selectedPrestIds = state.selectedPrestIds

        Object.entries(obj).forEach(([id, quantity])=>{

            // find prestation and variant
            let prestation = prestations.find(prest=>{
                return !!prest.variants.find((v)=>{
                    return v.id===id
                })
            })

            let variant = variants.find(v=>v.id === id)
            const isFlexVariant = !!variant.pvFlex
            if (!variant) throw new Error("prestation variant not found while adding selection")

            if(isFlexVariant && !validateFlexSelection(state, variant)) {
                commit(
                    "setErrorMessageOpen", 
                    "errorMessages_PVFlex"
                )
                return
            }
            
            const currentQuantity = selectedPrestIds[id] || 0
            const difference = quantity - currentQuantity
            const company = getCookie('company')
            
            // unselect other variants
            prestation.variants.forEach((prestVariant)=>{
                if (prestVariant.id === id) return
                const unselectObject = {}
                unselectObject[prestVariant.id] = 0
                // unselect all other variant flex type
                if(isFlexVariant && state.selectedFlexTypes[prestVariant.pvFlex] > 0) {
                    commit("setFlexTypeAmount", {flexType: prestVariant.pvFlex, increaseAmount: false})
                }
                commit("setSelectedPrestIds", unselectObject)
            })

            const remainingAdditionalHebergements = getters.remainingAdditionalHebergements
            
            if (difference > 0) { // if adding - check for validity
                if (store.getters.locale === "fr_FR_CSE" && company === 'cgos' && selectedPrestationsAmount >= 1) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanOneOnCGOS'
                    )
                    return
                }
                if (store.getters.locale === "fr_FR_CSE" && company === 'cgos' && prestation.capacity < getParticipantsAmount()) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_lessPrestationThanAdultsCGOS'
                    )
                    return
                }
                if (remainingAdditionalHebergements === 0) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }
                if (remainingAdditionalHebergements - difference < 0) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }
                if (quantity > variant.quantity) {
                    commit(
                        "setErrorMessageOpen", 
                        'errorMessages_morePrestationsSelectedThanAdults'
                    )
                    return
                }


            }
    
            // commit if entry is valid
            const object = {}
            object[id] = quantity
            
            // If we have a quantity, add 1 to  the amount of the flex type, add the selected fusion id
            if(isFlexVariant && quantity ) {
                commit("setFlexTypeAmount", {flexType: variant.pvFlex})
                commit("addSelectedPrestIdFusion", variant.prestIdFusion)
            // If we do not have a quantity, subtract 1 from the amount of the flex type, remove the selected fusion id
            }else if(isFlexVariant && !quantity){
                commit("setFlexTypeAmount", {flexType: variant.pvFlex, increaseAmount: false})
                commit("removeSelectedPrestIdFusion", variant.prestIdFusion)
            }

            commit("setSelectedPrestIds", object)
            
            // close dropdown
            commit("setSelectDropdownOpen_prestId", {id:'', current_select_location:''})
        })

        if (!state.scrollToPrestationFired && scrollToSummary) {
            setTimeout(()=>{
                window.dispatchEvent(new CustomEvent("smoothScrollToSelector", {detail: {selector: "#summary", block: "center"}}))
            }, 200)
            commit("setScrollToPrestationFired", true)
        }

        dispatch("refreshDataStoredOnWindow")
    },
}


function validateFlexSelection(state, variant) {
    const isPrestationSelected = state.selectedPrestIdsFusion.has(variant.prestIdFusion);
    const isFlexTypeSelected = state.selectedFlexTypes[variant.pvFlex];

    // Return true if flex type is selected, or no prestation is selected
    if (isFlexTypeSelected || !state.selectedPrestIdsFusion.size) {
        return true;
    }

    // When flex type is not selected
    // Return true if exactly one prestation is selected and it matches the current variant
    // Otherwise, return false
    return isPrestationSelected && state.selectedPrestIdsFusion.size === 1;
}